import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getResignation, resignationResponse } from "../api/resignation.api";
import { Resignation, ResignationResponse } from "../resignation.types";

export const resignationQueryKeys = {
  all: ["emp-resignation"] as const,
  list: (employeeId: number) =>
    [resignationQueryKeys.list, "list", employeeId] as const,
};

export const useResignation = () => {
  return useQuery<Resignation[]>({
    queryKey: resignationQueryKeys.all,
    queryFn: () => getResignation(),
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60,
  });
};

export const useResignationMutation = () => {

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      employeeId,
      response,
    }: {
      id: string;
      employeeId: number,
      response: ResignationResponse;
    }) => resignationResponse({ id, employeeId, response }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: resignationQueryKeys.all
      });
    },
  });
};
